import { render } from "./caseForm.vue?vue&type=template&id=365c8f46&scoped=true"
import script from "./caseForm.vue?vue&type=script&lang=js"
export * from "./caseForm.vue?vue&type=script&lang=js"

import "./caseForm.vue?vue&type=style&index=0&id=365c8f46&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/gafwa_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365c8f46"]])

export default __exports__